import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { CBP_CASE_MANAGER_REFERENCE_DATA_URL } from '../../../constants';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getCbpCaseManagerReferenceData = createAsyncThunk(
  'stop/getCbpCaseManagerReferenceData',
  async (params) => {
    const config = {
      headers: {
        Authorization: params,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(CBP_CASE_MANAGER_REFERENCE_DATA_URL, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });
    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const cbpCaseManagerReferenceSlice = createSlice({
  name: 'stop/cbpCaseManagerReference',
  initialState: null,
  reducers: {
    resetCbpCaseManagerReference: () => null,
  },
  extraReducers: {
    [getCbpCaseManagerReferenceData.fulfilled]: (state, action) => action.payload,
  },
});

export const { resetCbpCaseManagerReference } = cbpCaseManagerReferenceSlice.actions;

export default cbpCaseManagerReferenceSlice.reducer;
